export default function Header() {
    // function handleMenuOnScroll() {
    //     const menu = document.getElementById('header');
        
    //     // desktop: mostra/esconde o menu de acordo com o scroll (páginas internas)
    //     if (screen.innerWidth > 992) {
    //         let lastScroll = 0;
    
    //         window.addEventListener('scroll', () => {
    //             const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    //             // evita comportamento negativo em iOS
    //             if (currentScroll <= 0) {
    //                 menu.classList.remove('scrolled-up', 'scrolled-down');
    //                 return;
    //             }
    
    //             if (currentScroll > lastScroll) {
    //                 // scroll para baixo
    //                 menu.classList.remove('scrolled-up');
    //                 menu.classList.add('scrolled-down');
    //             } else {
    //                 // scroll para cima
    //                 menu.classList.remove('scrolled-down');
    //                 menu.classList.add('scrolled-up');
    //             }
    
    //             lastScroll = currentScroll;
    //         });
    //     }
    // }

    // btn mostra menu (home apenas)
    function btnShowMenu() {
        const btn = document.getElementById('btn-show-menu');
        const menu = document.getElementById('header');
        let lastScroll = 0;

        if (!btn || !menu) {
            return;
        }

        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScroll > 0) {
                // evita comportamento negativo em iOS
                if (currentScroll <= 0) {
                    menu.classList.remove('scrolled-up', 'scrolled-down');
                    return;
                }
    
                // scroll: esconde menu e mostra btn
                if (currentScroll != lastScroll) {
                    hideHeader();
                    showBtn();
                }                
            } else {
                showHeader();
                hideBtn();
            }

            lastScroll = currentScroll;
        });
        
        // click no btn: mostra menu e esconde btn
        btn.addEventListener('click', function() {
            hideBtn();
            showHeader();
        })

        function hideHeader() {
            menu.classList.remove('scrolled-up');
            menu.classList.add('scrolled-down');
        }

        function showHeader() {
            menu.classList.add('scrolled-up');
            menu.classList.remove('scrolled-down');
        }

        function showBtn() {
            btn.classList.add('show');
            btn.setAttribute('aria-hidden', 'false');
        }

        function hideBtn() {
            btn.classList.remove('show');
            btn.setAttribute('aria-hidden', 'true');
        }
    }

    const MOBILE_NAV_MAX = 900;

    /** Home (sem #navOverlay): gaveta lateral + ícones sociais como antes */
    function initLegacyMobileDrawerMenu() {
        const menuToggle = document.querySelector('.menu-toggle');
        const headerNav = document.querySelector('.header-nav');
        const headerRight = document.querySelector('.header-right');
        const body = document.body;

        if (!menuToggle || !headerNav) {
            return;
        }

        menuToggle.addEventListener('click', () => {
            const isActive = menuToggle.classList.toggle('active');
            headerNav.classList.toggle('active');

            if (headerRight) {
                headerRight.classList.toggle('active');
            }

            if (isActive) {
                body.style.overflow = 'hidden';
            } else {
                body.style.overflow = '';
            }
        });

        headerNav.querySelectorAll('.nav-link').forEach((link) => {
            link.addEventListener('click', () => {
                menuToggle.classList.remove('active');
                headerNav.classList.remove('active');
                if (headerRight) {
                    headerRight.classList.remove('active');
                }
                body.style.overflow = '';
            });
        });

        window.addEventListener('resize', () => {
            if (window.innerWidth > MOBILE_NAV_MAX) {
                menuToggle.classList.remove('active');
                headerNav.classList.remove('active');
                if (headerRight) {
                    headerRight.classList.remove('active');
                }
                body.style.overflow = '';
            }
        });
    }

    /** Páginas internas: overlay + GSAP (exige #navOverlay no DOM) */
    function initMobileMenu() {
        if (!document.getElementById('navOverlay')) {
            initLegacyMobileDrawerMenu();
            return;
        }

        const menuBtn = document.getElementById('menuBtn');
        const closeMenuBtn = document.getElementById('closeMenu');
        const navOverlay = document.getElementById('navOverlay');
        const menuWrapper = document.getElementById('menuWrapper');
        const goProdutos = document.getElementById('goProdutos');
        const goBack = document.getElementById('goBack');
        const logoImg = document.querySelector('#header .header-logo img');
        const bodyEl = document.body;
        const navBg = document.querySelector('.nav-overlay .nav-bg');

        if (!menuBtn || !navOverlay || !menuWrapper || !navBg || !goProdutos) {
            return;
        }

        let isMenuOpen = false;
        let isAnimating = false;
        let pendingClose = false;
        let pendingBack = false;
        let pendingProduct = false;

        function isMobileNav() {
            return window.innerWidth <= MOBILE_NAV_MAX;
        }

        function getCircleOrigin() {
            const btnRect = menuBtn.getBoundingClientRect();
            return {
                originX: btnRect.left + btnRect.width / 2,
                originY: btnRect.top + btnRect.height / 2,
            };
        }

        function setMenuAria(open) {
            menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
            navOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        function waitForGsap(callback) {
            if (typeof window.gsap !== 'undefined') {
                callback(window.gsap);
                return;
            }
            setTimeout(() => waitForGsap(callback), 50);
        }

        waitForGsap((gsap) => {
            function animateCircleOpen() {
                const { originX, originY } = getCircleOrigin();
                const pos = `${originX}px ${originY}px`;
                gsap.fromTo(
                    navBg,
                    { clipPath: `circle(0% at ${pos})` },
                    {
                        clipPath: `circle(160% at ${pos})`,
                        duration: 1.8,
                        ease: 'power3.inOut',
                    },
                );
            }

            function animateCircleClose(onComplete) {
                const { originX, originY } = getCircleOrigin();
                const pos = `${originX}px ${originY}px`;
                gsap.to(navBg, {
                    clipPath: `circle(0% at ${pos})`,
                    duration: 1.0,
                    ease: 'power3.inOut',
                    delay: 0.2,
                    onComplete,
                });
            }

            function processPendingActions() {
                if (pendingClose && !isAnimating && isMenuOpen) {
                    pendingClose = false;
                    menuBtn.click();
                    return;
                }
                if (
                    pendingProduct &&
                    !isAnimating &&
                    isMenuOpen &&
                    !menuWrapper.classList.contains('showing-submenu')
                ) {
                    pendingProduct = false;
                    goProdutos.click();
                    return;
                }
                if (pendingBack && !isAnimating && menuWrapper.classList.contains('showing-submenu')) {
                    pendingBack = false;
                    goBack.click();
                }
            }

            function toggleMenu() {
                if (!isMobileNav()) return;
                if (isAnimating) return;

                isMenuOpen = !isMenuOpen;
                isAnimating = true;

                menuBtn.classList.toggle('is-open', isMenuOpen);
                bodyEl.classList.toggle('menu-open', isMenuOpen);
                setMenuAria(isMenuOpen);

                if (isMenuOpen) {
                    bodyEl.style.overflow = 'hidden';
                    navOverlay.classList.remove('closing');
                    navOverlay.classList.add('active');
                    animateCircleOpen();

                    const mainItems = document.querySelectorAll('.nav-overlay .main-pane .menu-item');
                    gsap.set(mainItems, { y: 60, opacity: 0 });
                    gsap.to(mainItems, {
                        y: 0,
                        opacity: 1,
                        duration: 1.1,
                        stagger: 0.08,
                        ease: 'power3.out',
                        delay: 0.8,
                        onComplete: () => {
                            isAnimating = false;
                            processPendingActions();
                        },
                    });

                    gsap.fromTo(
                        '.nav-overlay .main-pane .index',
                        { opacity: 0, x: -10 },
                        {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            stagger: 0.08,
                            ease: 'power3.out',
                            delay: 0.7,
                        },
                    );

                    if (logoImg) {
                        gsap.to(logoImg, { scale: 0.92, opacity: 0.9, duration: 0.6, ease: 'expo.out' });
                    }
                } else {
                    bodyEl.style.overflow = '';
                    navOverlay.classList.add('closing');
                    animateCircleClose(() => {
                        navOverlay.classList.remove('active', 'closing');
                    });

                    if (logoImg) {
                        gsap.to(logoImg, { scale: 1, opacity: 1, duration: 0.6, ease: 'expo.out' });
                    }

                    const mainItems = document.querySelectorAll('.nav-overlay .main-pane .menu-item');
                    gsap.to(mainItems, {
                        y: -30,
                        opacity: 0,
                        duration: 0.5,
                        stagger: 0.04,
                        ease: 'expo.in',
                        onComplete: () => {
                            isAnimating = false;
                            processPendingActions();
                            setTimeout(() => {
                                menuWrapper.classList.remove('showing-submenu');
                            }, 600);
                        },
                    });
                }
            }

            menuBtn.addEventListener('click', (e) => {
                if (!isMobileNav()) return;
                e.preventDefault();
                toggleMenu();
            });

            if (closeMenuBtn) {
                closeMenuBtn.addEventListener('click', () => {
                    if (!isMenuOpen) return;
                    if (isAnimating) {
                        pendingClose = true;
                        return;
                    }
                    toggleMenu();
                });
            }

            goProdutos.addEventListener('click', (e) => {
                e.preventDefault();
                if (!isMobileNav() || !isMenuOpen) return;
                if (isAnimating) {
                    pendingProduct = true;
                    return;
                }
                isAnimating = true;

                const mainItems = document.querySelectorAll('.nav-overlay .main-pane .menu-item');
                gsap.to(mainItems, {
                    x: -30,
                    opacity: 0,
                    duration: 0.5,
                    stagger: 0.04,
                    ease: 'expo.in',
                    onComplete: () => {
                        menuWrapper.classList.add('showing-submenu');

                        const subItems = document.querySelectorAll('.nav-overlay .sub-pane .menu-item');
                        gsap.set(subItems, { x: 40, opacity: 0 });
                        gsap.to(subItems, {
                            x: 0,
                            opacity: 1,
                            duration: 0.9,
                            stagger: 0.07,
                            ease: 'expo.out',
                            delay: 0.15,
                            onComplete: () => {
                                isAnimating = false;
                                processPendingActions();
                            },
                        });

                        gsap.fromTo(
                            '.nav-overlay .back-btn',
                            { opacity: 0, x: -15 },
                            { opacity: 1, x: 0, duration: 0.7, ease: 'expo.out', delay: 0.1 },
                        );
                    },
                });
            });

            function backFromSubmenu() {
                if (!isMobileNav() || !isMenuOpen) return;
                if (isAnimating) {
                    pendingBack = true;
                    return;
                }
                isAnimating = true;

                const subItems = document.querySelectorAll('.nav-overlay .sub-pane .menu-item');
                gsap.to(subItems, {
                    x: 30,
                    opacity: 0,
                    duration: 0.45,
                    stagger: 0.04,
                    ease: 'expo.in',
                    onComplete: () => {
                        menuWrapper.classList.remove('showing-submenu');

                        const mainItems = document.querySelectorAll('.nav-overlay .main-pane .menu-item');
                        gsap.set(mainItems, { x: -30, opacity: 0 });
                        gsap.to(mainItems, {
                            x: 0,
                            opacity: 1,
                            duration: 0.9,
                            stagger: 0.06,
                            ease: 'expo.out',
                            delay: 0.1,
                            onComplete: () => {
                                isAnimating = false;
                                processPendingActions();
                            },
                        });
                    },
                });

                gsap.to('.nav-overlay .back-btn', {
                    opacity: 0,
                    x: -10,
                    duration: 0.3,
                    ease: 'expo.in',
                });
            }

            goBack.addEventListener('click', backFromSubmenu);
            goBack.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    backFromSubmenu();
                }
            });

            document.querySelectorAll('.nav-overlay .menu-link').forEach((link) => {
                if (link.id === 'goProdutos') return;
                link.addEventListener('click', () => {
                    if (isMenuOpen && !isAnimating) {
                        toggleMenu();
                    }
                });
                const lt = link.querySelector('.link-text');
                if (!lt) return;
                link.addEventListener(
                    'touchstart',
                    () => {
                        gsap.to(lt, { scale: 0.97, duration: 0.15, ease: 'power2.out' });
                    },
                    { passive: true },
                );
                link.addEventListener(
                    'touchend',
                    () => {
                        gsap.to(lt, { scale: 1, duration: 0.6, ease: 'elastic.out(1, 0.5)' });
                    },
                    { passive: true },
                );
            });

            const hamburgerLines = menuBtn.querySelectorAll('span');
            menuBtn.addEventListener('mouseenter', () => {
                if (!isMenuOpen && hamburgerLines[1]) {
                    gsap.to(hamburgerLines[1], { width: '100%', duration: 0.3, ease: 'expo.out' });
                }
            });
            menuBtn.addEventListener('mouseleave', () => {
                if (!isMenuOpen && hamburgerLines[1]) {
                    gsap.to(hamburgerLines[1], { width: '55%', duration: 0.4, ease: 'expo.out' });
                }
            });

            window.addEventListener('resize', () => {
                if (window.innerWidth > MOBILE_NAV_MAX) {
                    menuBtn.classList.remove('is-open');
                    bodyEl.classList.remove('menu-open');
                    navOverlay.classList.remove('active', 'closing');
                    menuWrapper.classList.remove('showing-submenu');
                    bodyEl.style.overflow = '';
                    isMenuOpen = false;
                    isAnimating = false;
                    pendingClose = false;
                    pendingBack = false;
                    pendingProduct = false;
                    setMenuAria(false);
                    if (logoImg) {
                        gsap.set(logoImg, { scale: 1, opacity: 1 });
                    }
                }
            });
        });
    }

    function initDropdowns() {
        // Verifica se GSAP está disponível PRIMEIRO
        if (typeof window === 'undefined' || typeof window.gsap === 'undefined') {
            setTimeout(initDropdowns, 50);
            return;
        }

        const gsap = window.gsap;
        const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');
        const dropdownContainer = document.querySelector('.dropdown-container');
        const allDropdownContents = document.querySelectorAll('[data-dropdown]');

        if (!dropdownTriggers.length || !dropdownContainer) {
            return;
        }

        let isContainerOpen = false;

        // 🔓 Abre dropdown
        function openDropdown(trigger) {
            const targetId = trigger.dataset.dropdownTrigger;
            const targetDropdown = document.querySelector(`[data-dropdown="${targetId}"]`);
            const dropdownItems = targetDropdown ? targetDropdown.querySelectorAll('.dropdown-item') : [];

            if (!targetDropdown) return;

            // Remove active de todos os triggers
            dropdownTriggers.forEach(t => {
                const link = t.querySelector('.nav-link-dropdown');
                if (link) link.classList.remove('active');
            });

            // Ativa trigger atual
            const currentLink = trigger.querySelector('.nav-link-dropdown');
            if (currentLink) currentLink.classList.add('active');

            // Esconde todos os dropdowns
            allDropdownContents.forEach(content => {
                content.classList.remove('active');
            });

            // Mostra apenas o correto
            targetDropdown.classList.add('active');

            // Abre container
            if (!isContainerOpen) {
                isContainerOpen = true;
                dropdownContainer.classList.add('open');
                dropdownContainer.style.visibility = 'visible';
            }

            // Anima itens
            gsap.killTweensOf(dropdownItems);
            gsap.fromTo(
                dropdownItems,
                { opacity: 0, y: 10 },
                {
                    opacity: 1,
                    y: 0,
                    stagger: 0.05,
                    duration: 0.3,
                    ease: 'power2.out'
                }
            );
        }

        // 🔒 Fecha tudo
        function closeDropdown() {
            if (!isContainerOpen) return;

            dropdownTriggers.forEach(t => {
                const link = t.querySelector('.nav-link-dropdown');
                if (link) link.classList.remove('active');
            });

            dropdownContainer.classList.remove('open');
            isContainerOpen = false;

            setTimeout(() => {
                if (!isContainerOpen) {
                    dropdownContainer.style.visibility = 'hidden';
                    allDropdownContents.forEach(content => {
                        content.classList.remove('active');
                    });
                }
            }, 300);
        }

        // ✅ ENTER no trigger → abre
        dropdownTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                openDropdown(trigger);
            });

            // ✅ LEAVE do trigger
            trigger.addEventListener('mouseleave', (e) => {
                const related = e.relatedTarget;

                // Se foi para o dropdown container, NÃO fecha
                if (dropdownContainer.contains(related)) return;

                // Caso contrário (outro link / página)
                closeDropdown();
            });
        });

        // ✅ LEAVE do container
        dropdownContainer.addEventListener('mouseleave', (e) => {
            const related = e.relatedTarget;

            // Se voltou para algum trigger, NÃO fecha
            for (const trigger of dropdownTriggers) {
                if (trigger.contains(related)) return;
            }

            // Caso contrário, fecha
            closeDropdown();
        });
    }

    function init() {
        initDropdowns();
        initMobileMenu();

        if (document.getElementById('home') || document.getElementById('home3')) {
            btnShowMenu();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
